// API configuration based on environment
const normalizeBaseUrl = (baseUrl) => {
  if (!baseUrl) {
    return '';
  }

  const trimmed = baseUrl.trim();
  if (trimmed === '' || trimmed === '/') {
    return '';
  }

  return trimmed.endsWith('/') ? trimmed.slice(0, -1) : trimmed;
};

const API_BASE_URL = normalizeBaseUrl(process.env.REACT_APP_API_BASE_URL);

export const apiConfig = {
  baseURL: API_BASE_URL,
  endpoints: {
    auth: {
      login: '/api/auth/login',
      register: '/api/auth/register',
      profile: '/api/auth/profile',
      forgotPassword: '/api/auth/password/forgot',
      resetPassword: '/api/auth/password/reset'
    },
    goals: {
      base: '/api/goals',
      stats: '/api/goals/stats'
    }
  }
};

// Helper function to build full API URLs
export const buildApiUrl = (endpoint) => {
  if (!endpoint) {
    return '';
  }

  const normalizedEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;

  if (!API_BASE_URL) {
    return normalizedEndpoint;
  }

  return `${API_BASE_URL}${normalizedEndpoint}`;
};

// Helper function to get auth headers
export const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
  };
};

export default apiConfig;
